import styles from './styles.module.css'

export const Error = ({error}) => {
    return (
        <div className={styles.error}>{error}</div>
    )
}
